// extracted by mini-css-extract-plugin
export default {"header":"MapPage_header__1i2aW","map":"MapPage_map__swJWv"};